
import { useState } from 'react';

interface Treatment {
  id: string;
  title: string;
  icon: string;
  description: string;
  details: string;
}

const treatments: Treatment[] = [
  {
    id: 'hpb',
    title: 'Hiperplasia Prostática Benigna (HPB)',
    icon: 'ri-heart-pulse-line',
    description: 'Crecimiento no canceroso de la próstata que puede causar problemas urinarios.',
    details: 'La HPB es común en hombres mayores de 50 años. Tratamos desde medicamentos hasta procedimientos mínimamente invasivos como la RTU de próstata, mejorando significativamente la calidad de vida del paciente.'
  },
  {
    id: 'calculos',
    title: 'Cálculos Renales',
    icon: 'ri-contrast-drop-line',
    description: 'Formaciones sólidas en los riñones que pueden causar dolor intenso.',
    details: 'Utilizamos tecnología de vanguardia como litotricia extracorporal y ureteroscopia para fragmentar y extraer cálculos de forma mínimamente invasiva, reduciendo el tiempo de recuperación.'
  },
  {
    id: 'infecciones',
    title: 'Infecciones Urinarias',
    icon: 'ri-virus-line',
    description: 'Infecciones del tracto urinario que requieren tratamiento especializado.',
    details: 'Diagnóstico preciso mediante cultivos y tratamiento dirigido con antibióticos específicos. Identificamos y tratamos las causas subyacentes para prevenir recurrencias.'
  },
  {
    id: 'disfuncion',
    title: 'Disfunción Eréctil',
    icon: 'ri-heart-line',
    description: 'Dificultad para lograr o mantener una erección satisfactoria.',
    details: 'Ofrecemos tratamientos integrales desde medicamentos orales hasta terapias avanzadas como ondas de choque y prótesis de pene, siempre con máxima discreción y privacidad.'
  },
  {
    id: 'cancer-prostata',
    title: 'Cáncer de Próstata',
    icon: 'ri-microscope-line',
    description: 'Detección temprana y tratamiento del cáncer prostático.',
    details: 'Realizamos biopsias guiadas por ultrasonido, estadificación completa y ofrecemos opciones de tratamiento desde vigilancia activa hasta cirugía robótica, según cada caso.'
  },
  {
    id: 'peyronie',
    title: 'Enfermedad de Peyronie',
    icon: 'ri-pulse-line',
    description: 'Curvatura anormal del pene que puede afectar la función sexual.',
    details: 'Tratamiento médico y quirúrgico personalizado para corregir la curvatura y restaurar la función sexual normal, utilizando técnicas reconstructivas avanzadas.'
  },
  {
    id: 'incontinencia',
    title: 'Incontinencia Urinaria',
    icon: 'ri-drop-line',
    description: 'Pérdida involuntaria de orina que afecta la calidad de vida.',
    details: 'Evaluación integral y tratamientos desde fisioterapia pélvica hasta procedimientos quirúrgicos mínimamente invasivos como slings uretrales.'
  },
  {
    id: 'varicocele',
    title: 'Varicocele',
    icon: 'ri-temp-hot-line',
    description: 'Dilatación de las venas del escroto que puede afectar la fertilidad.',
    details: 'Corrección quirúrgica mediante técnicas microquirúrgicas para preservar la fertilidad y aliviar las molestias, con excelentes resultados estéticos y funcionales.'
  }
];

export default function Treatments() {
  const [selectedTreatment, setSelectedTreatment] = useState<string | null>(null);

  const handleTreatmentClick = (treatmentId: string) => {
    setSelectedTreatment(selectedTreatment === treatmentId ? null : treatmentId);
  };

  return (
    <section id="tratamientos" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111317] mb-4">
            Lo que Tratamos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Especialistas en urología masculina con tratamientos integrales y personalizados
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {treatments.map((treatment) => (
            <div key={treatment.id} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <div className="p-6">
                <div className="w-16 h-16 bg-[#1B84FF]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${treatment.icon} text-2xl text-[#1B84FF]`}></i>
                </div>
                
                <h3 className="text-lg font-semibold text-[#111317] mb-3 text-center">
                  {treatment.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 text-center">
                  {treatment.description}
                </p>
                
                <button
                  onClick={() => handleTreatmentClick(treatment.id)}
                  className="w-full bg-[#0B2A4A] text-white py-2 px-4 rounded-lg hover:bg-[#1B84FF] transition-colors cursor-pointer whitespace-nowrap"
                >
                  {selectedTreatment === treatment.id ? 'Ocultar información' : 'Más información'}
                </button>
                
                {selectedTreatment === treatment.id && (
                  <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      {treatment.details}
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
